import { render } from "./CheckRadio.vue?vue&type=template&id=cf034758&scoped=true&ts=true"
import script from "./CheckRadio.vue?vue&type=script&lang=ts"
export * from "./CheckRadio.vue?vue&type=script&lang=ts"

import "./CheckRadio.vue?vue&type=style&index=0&id=cf034758&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf034758"]])

export default __exports__